import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicScriptLoaderService } from './service/dynamic-script-loader.service';
import { throwIfAlreadyLoaded } from './guard/module-import.guard';
import { AppInitializer, appInitializerFactory } from './service/app-initializer';
import { AuthGuard } from './guard/auth.guard';
import { AuthService } from '../../services/auth.service';
import { RightSidebarService } from '../../services/rightsidebar.service';
@NgModule({
  declarations: [],
  imports: [CommonModule
  ],

  providers: [
    AppInitializer,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppInitializer],
      multi: true
    },
    RightSidebarService,
    AuthGuard,
    AuthService,
    DynamicScriptLoaderService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
